import { useCreate } from '@refinedev/core';

export type CreateCompanyInput = {
  name: string;
  fca_firm_reference_number?: string;
};

export const useCreateCompanyMutation = () => {
  const { mutateAsync, error, isLoading } = useCreate<CreateCompanyInput>();

  const createCompany = async (input: CreateCompanyInput) => {
    await mutateAsync({
      resource: 'admin/companies',
      values: input,
    });
  };

  return {
    createCompany,
    isLoading,
    error,
  };
};
